import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { BRAND_UPPER, SUPPORT_EMAIL } from "@/lib/site";
import useT from "@/i18n";

const cols = [
  { k: "product", links: [["/download", "download"], ["/latest-version", "latest"], ["/changelog", "changelog"], ["/about", "about"]] },
  { k: "company", links: [["/support", "support"], ["/contact", "contact"], ["/privacy-policy", "privacy"], ["/terms", "terms"]] },
];

export const Footer = () => {
  const { t, lp } = useT();
  const f = t.footer;
  return (
  <footer className="border-t mt-12 safe-bottom" style={{ borderColor: "rgba(255,255,255,0.06)", background: "#040912" }}>
    <div className="max-w-7xl mx-auto safe-x sm:px-8 py-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
      <div>
        <Logo testId="footer-logo" />
        <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-xs">{f.desc}</p>
      </div>
      {cols.map((c) => (
        <div key={c.k}>
          <h2 className="text-[11px] tracking-[0.3em] uppercase text-slate-500">{f[c.k]}</h2>
          <ul className="mt-3">
            {c.links.map(([to, key]) => (
              <li key={to}>
                <Link to={lp(to)} className="tap inline-flex items-center text-sm text-slate-300 hover:text-[#7DDCFF] transition-colors" data-testid={`footer-link-${to.slice(1)}`}>{f.links[key]}</Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <div>
        <h2 className="text-[11px] tracking-[0.3em] uppercase text-slate-500">{f.support}</h2>
        <a href={`mailto:${SUPPORT_EMAIL}`} className="tap inline-flex items-center mt-3 text-sm text-slate-200 hover:text-[#7DDCFF] break-all" data-testid="footer-support-email">{SUPPORT_EMAIL}</a>
        <p className="text-xs text-slate-500">{f.response}</p>
        <Link to="/admin/login" rel="nofollow" className="tap inline-flex items-center text-xs text-slate-600 hover:text-[#7DDCFF] transition-colors" data-testid="footer-admin-link">Admin</Link>
      </div>
    </div>
    <div className="max-w-7xl mx-auto safe-x sm:px-8 py-6 border-t flex flex-col sm:flex-row gap-2 justify-between text-xs text-slate-500" style={{ borderColor: "rgba(255,255,255,0.05)" }}>
      <p>© {new Date().getFullYear()} {BRAND_UPPER}. {f.rights}</p>
      <p>{f.madeIn}</p>
    </div>
  </footer>
  );
};
